export default "__VITE_ASSET__DgbZshB$__"